//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

  data () {
  return {
    erweima:'',
    data:{},
    service_url:'',
	info:'',
  }
  },
  components:{
    'v-footer': "footer"
  },
  mounted(){
    // 公众号
    this.$axios.post('/v8/PC_index/number_two').then(res=>{
      if(res.data.code==200){
        this.erweima=res.data.data
      }
    })
	this.$axios.post(`/v8/PC_Member/pc_ip_info`).then(res =>{
		  
	   		if(res.data.code == 200){
	   		  this.info=res.data.data
	   		}
	   })
     this.$axios.post( `/v4/Index/wxServe`).then(res => {
      this.service_url=res.data.data.service_url;
    })
     this.$axios.post( `/v9/index/getPcGetInfo`).then(res => {
      if(res.data.code == '1'){
        this.data=res.data.data
      }
    })
  },
  methods: {
    apply(){
     this.$axios.post(`/v1/member/vip`).then(res=>{
        if(res.data.code==200){
            if(res.data.data.member_info.is_teacher==0){
                this.$tips('您还不是导师~');
            }else{
              this.$router.push("/teacher");
            }
          }
    })
   },
    toPage(router){
      this.$router.push(router)
    },
  },
  props:{
      nowHref: {
        type: String,
        default: ""
      },
    },
  created () {
  }
}



// WEBPACK FOOTER //
// ./src/components/common/footer.vue